/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum MachineParametersControlType {
    RELAIS = 'RELAIS',
    PULSE = 'PULSE'
}


export function MachineParametersControlTypeFromJSON(json: any): MachineParametersControlType {
    return MachineParametersControlTypeFromJSONTyped(json, false);
}

export function MachineParametersControlTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MachineParametersControlType {
    return json as MachineParametersControlType;
}

export function MachineParametersControlTypeToJSON(value?: MachineParametersControlType | null): any {
    return value as any;
}

